import React from 'react';
import './TableFilter.css';

/**
 * TableFilter - componente genérico para filtros de tabelas
 * @param {Array} filters - [{ label, value, options: [{ value, label }], onChange }]
 */
function TableFilter({ filters }) {
  return (
    <div className="table-filter-container">
      {filters.map((filter) => (
        <div className="table-filter-group" key={filter.value}>
          <label htmlFor={filter.value}>{filter.label}:</label>
          <select
            id={filter.value}
            value={filter.selected}
            onChange={e => filter.onChange(e.target.value)}
          >
            {filter.options.map(opt => (
              <option key={opt.value} value={opt.value}>{opt.label}</option>
            ))}
          </select>
        </div>
      ))}
    </div>
  );
}

export default TableFilter;
